import { render, staticRenderFns } from "./GRadioButton.vue?vue&type=template&id=f2b152ee&scoped=true&"
import script from "./GRadioButton.vue?vue&type=script&lang=js&"
export * from "./GRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./GRadioButton.vue?vue&type=style&index=0&id=f2b152ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b152ee",
  null
  
)

export default component.exports